import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchWorkItemsFromWorker = async (
  workerID: string,
  initialDate: Date
) => {
  let params = {};

  if (initialDate) {
    const day = initialDate.getDate();
    const month = initialDate.getMonth();
    const year = initialDate.getFullYear();
    params = { day, month, year };
  }

  const { data } = await apiInputService.get(
    `/workItem/profile/CONSOLIDATED_WORKER/requestParam/${workerID}`,
    {
      params,
    }
  );

  return data;
};

export const useWorkItemsFromCWorker = (
  workerID: string,
  initialDate?: Date,
  options?: any
) => {
  return useQuery<any[]>(
    ["work-items-worker", workerID, initialDate?.toLocaleDateString()],
    () => fetchWorkItemsFromWorker(workerID, initialDate),
    {
      enabled: Boolean(workerID),
      ...options,
    }
  );
};
